<template>
  <IQOSTable 
    :cols="[
        {
            title: 'Дата',
            key: 'created_at',
            date: true
        },
        {
            title: 'Час',
            key: 'created_at',
            time: true
        },
        {
            title: `Ім'я клієнта`,
            key: 'name'
        },
        {
            title: 'Телефон клієнта',
            key: 'phone'
        },
        {
            title: 'Приз',
            key: 'prize_name',
            renderer: (k) => k.prize_name || '-'
        }
    ]" 
    :rows="rolls">

    </IQOSTable>
</template>

<script>
import CasinoAPI from "@/api/casino"

export default {
    data() {
        return {
            rolls: []
        }
    },
    mounted() {
        CasinoAPI.getRollsHistory(this.$store.state.cafe._id).then(data => {
            this.rolls = data.rolls;
        });
    }
}
</script>

<style>

</style>